<template>
    <div class="home-admin-container">
        <div class="left-admin-container">
            <div class="left-logo-container" @click="userToHome">
                <img class="img-100" src="../../assets/logo/logo.png" alt="博雅美育五馆">
            </div>
            <div class="left-slogan-container">博雅美育浸润·五馆合一</div>
        </div>
        <div class="middle-admin-container"></div>
        <div class="right-admin-container">
            <span v-if="role==='1'" class="span1">超级管理员</span>
            <span v-if="role==='2'" class="span1">平台管理员</span>
            <span v-if="role==='3'" class="span1">一级代理</span>
            <span v-if="role==='4'" class="span1">二级代理</span>
            <span v-if="role==='5'" class="span1">机构管理员</span>
            <span class="span2">{{userInfo?userInfo.trueName:''}}</span>
            <span class="span3" @click="userLogout">退出登录</span>
        </div>
    </div>
</template>


<script>
import {timestampToTime} from "@/utils/date";
export default {
    name: "adminHead",
    props: {
    },
    data() {
        return {
            timestampToTime,
            isLogin:this.$storage.get('isLogin'),
            userInfo : JSON.parse(this.$storage.get("userInfo")),
            role: this.$storage.get("role"),
        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted() {},
    methods: {
        userToHome(){
            this.$router.push("/museum/home")
        },
        userLogout(){
            this.$confirm("您正在退出当前登录，是否继续？", "退出系统", {
                confirmButtonText: "退出",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.$storage.remove("token")
                this.$storage.remove("userInfo")
                this.$storage.remove("role");
                this.$storage.remove("isLogin");
                this.isLogin = false;
                this.$router.push({ path: "/museum/home" });
            })
        },
    }

};
</script>

<style scoped lang="scss">
.home-admin-container{
    width: 100%;
    height: 59px;
    border-bottom: 1px solid #e5e8ec;
    display: flex;
    justify-content: space-between;
    padding: 8px 20px 8px 20px;
    box-sizing: border-box;
}
.left-admin-container {
    width: auto;
    min-width: 200px;
    height: 44px;
    display: flex;
    flex-shrink: 0;
}

.left-logo-container {
    width: 44px;
    height: 44px;
    display: flex;
    flex-shrink: 0;
    cursor: pointer;
}
.left-slogan-container {
    width: auto;
    height: 44px;
    display: flex;
    padding-left: 6px;
    box-sizing: border-box;
    font-weight: bold;
    font-size: 16px;
    line-height: 44px;
    font-family: sans-serif;
    color: #377f7f;
}

.middle-admin-container {
    flex: 1;
    height: 44px;
}

.right-admin-container {
    width: auto;
    min-width: 200px;
    height: 44px;
    text-align: right;
    font-size: 13px;
    font-family: sans-serif;
    line-height: 44px;
    flex-shrink: 0;
}
.span1{
    font-weight: bold;
    color: #333333;
    margin-right: 5px;
}
.span2{
    font-weight: bold;
    color: #333333;
    margin-right: 5px;
}
.span3{
    font-weight: bold;
    color: #377f7f;
    cursor: pointer;
}
@media (max-width: 1024px) {
    .left-slogan-container { display: none; }
    .right-admin-container { font-size: 12px; min-width: 150px; }
}
</style>